import { useLocation, useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useMobileLayout } from "@/hooks/useMobileLayout";

const TERMINAL_PREFIXES = ["/app/spot/", "/app/futures/", "/app/binary/"];

export default function MobileBottomTabs() {
  const location = useLocation();
  const navigate = useNavigate();
  const { resolved, isLoading } = useMobileLayout();
  const visibleTabs = resolved.tabs;

  if (TERMINAL_PREFIXES.some((p) => location.pathname.startsWith(p))) {
    return null;
  }

  return (
    <nav className="fixed bottom-0 inset-x-0 z-50 bg-card/95 backdrop-blur-xl border-t border-border pb-[env(safe-area-inset-bottom)]">
      <div className="flex items-center justify-around h-14">
        {isLoading
          ? [0, 1, 2, 3, 4].map((i) => (
              <div key={i} className="flex-1 h-full flex items-center justify-center" aria-hidden>
                <div className="h-8 w-12 rounded bg-muted/40 animate-pulse" />
              </div>
            ))
          : visibleTabs.map((tab) => {
              const isActive = location.pathname === tab.to || location.pathname.startsWith(tab.to + "/");
              return (
                <button
                  key={tab.key}
                  onClick={() => navigate(tab.to)}
                  className={cn(
                    "flex flex-col items-center justify-center gap-0.5 flex-1 h-full text-[10px] font-medium transition-colors",
                    isActive ? "text-primary" : "text-muted-foreground"
                  )}
                >
                  <tab.icon className={cn("h-5 w-5", isActive && "drop-shadow-[0_0_6px_hsl(var(--primary)/0.5)]")} />
                  <span>{tab.label}</span>
                </button>
              );
            })}
      </div>
    </nav>
  );
}
